var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDefaultCalendar = function SvgDefaultCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M5.968 12.479c.153 0 .23.115.23.23v1.54c0 .153-.115.23-.23.23H4.429c-.115 0-.23-.077-.23-.23v-1.54c0-.153.115-.23.23-.23zm3.227 0c.115 0 .23.115.23.23v1.54c0 .153-.115.23-.23.23H7.656c-.115 0-.23-.077-.23-.23v-1.54c0-.153.115-.23.23-.23zM5.968 9c.153 0 .23.115.23.23v1.54c0 .153-.115.23-.23.23H4.429c-.115 0-.23-.077-.23-.23V9.23c0-.153.115-.23.23-.23zm3.227 0c.115 0 .23.115.23.23v1.54c0 .153-.115.23-.23.23H7.656c-.115 0-.23-.077-.23-.23V9.23c0-.153.115-.23.23-.23zm3.227 3.479c.116 0 .231.115.231.23v1.54c0 .153-.115.23-.23.23h-1.54q-.172 0-.23-.23v-1.54c0-.153.115-.23.23-.23zm0-3.479c.116 0 .231.115.231.23v1.539c0 .115-.115.23-.23.23h-1.54c-.115 0-.191-.115-.23-.23V9.23c0-.115.115-.23.23-.23zm3.228 0c.153 0 .23.115.23.23v1.539c0 .115-.115.23-.23.23h-1.54c-.115 0-.192-.115-.23-.23V9.23c0-.115.115-.23.23-.23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 3v16H0V3zm-2 2H2v12h16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 1h2v6H5zm8 0h2v6h-2z"
  }))));
};
export default SvgDefaultCalendar;